import { Smartphone, Wifi } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useCompanion } from '@/hooks/useCompanion';
import { useQRPairing } from '@/hooks/useQRPairing';
import { useDevice } from '@/hooks/useDevice';

export function CompanionStatus() {
  const { deviceType } = useDevice();
  const { isPaired } = useQRPairing(deviceType);
  const { isController, isReceiver } = useCompanion();

  if (!isPaired) return null;

  return (
    <div className="fixed top-4 left-4 z-50 flex gap-2">
      {isPaired && (
        <Badge variant="secondary" className="gap-2 bg-primary/10 border-primary/20">
          <Wifi className="h-4 w-4 text-primary" />
          <span>Connected</span>
        </Badge>
      )}
      
      {isController && (
        <Badge variant="outline" className="gap-2">
          <Smartphone className="h-4 w-4" />
          <span>Remote Mode</span>
        </Badge>
      )}
      
      {isReceiver && (
        <Badge variant="outline" className="gap-2">
          <Smartphone className="h-4 w-4" />
          <span>Receiving</span>
        </Badge>
      )}
    </div>
  );
}